var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableReady = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#2F5BE1",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20 28a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.097 23.57a3.766 3.766 0 0 1 3.401-2.149h1.004c1.454 0 2.778.837 3.401 2.15a1 1 0 0 1-1.806.858 1.765 1.765 0 0 0-1.595-1.008h-1.004c-.682 0-1.302.392-1.595 1.008a1 1 0 0 1-1.806-.858Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20 18a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25 17.632c0 1.453-2.239 2.631-5 2.631s-5-1.178-5-2.631C15 16.178 17.239 15 20 15s5 1.178 5 2.632Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M23.05 17.397c.002 0-.002.007-.012.02.007-.014.012-.02.013-.02Zm-.285.235a2.878 2.878 0 0 0-.161-.091C22.04 17.244 21.123 17 20 17s-2.04.244-2.604.54a2.878 2.878 0 0 0-.161.092c.046.028.1.058.161.09.564.297 1.481.541 2.604.541s2.04-.244 2.604-.54a2.82 2.82 0 0 0 .161-.091Zm-5.816-.235c.001 0 .006.006.013.02-.01-.013-.014-.02-.013-.02Zm0 .47c0-.001.003-.008.013-.021-.007.014-.012.02-.013.02Zm6.089-.021c.01.013.014.02.013.02-.001 0-.006-.006-.013-.02ZM20 20.263c2.761 0 5-1.178 5-2.631C25 16.178 22.761 15 20 15s-5 1.178-5 2.632c0 1.453 2.239 2.631 5 2.631Z",
  clipRule: "evenodd"
})));
SvgTableReady.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableReady);
export default ForwardRef;